export default {
  placeholder: 'Vybrať zdroj dát',
};
